import React from 'react';
import { Box, Typography, Button, Container, Grid } from '@mui/material';

const HERO_BG =
  'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=1920&auto=format&fit=crop';

const Hero = () => {
  return (
    <Box
      id="home"
      sx={{
        position: 'relative',
        minHeight: { xs: '85vh', md: '90vh' },
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        backgroundImage: `url(${HERO_BG})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            'linear-gradient(105deg, rgba(26, 35, 126, 0.92) 0%, rgba(26, 35, 126, 0.75) 35%, rgba(26, 35, 126, 0.4) 60%, rgba(0,0,0,0.25) 100%)',
          pointerEvents: 'none'
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(ellipse at 30% 50%, rgba(255, 111, 0, 0.12) 0%, transparent 55%)',
          pointerEvents: 'none'
        }
      }}
    >
      <Container maxWidth="xl" sx={{ width: '100%', position: 'relative', zIndex: 1 }}>
        <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
          <Grid item xs={12} md={7}>
            <Box sx={{ maxWidth: { xs: '100%', md: '560px' } }}>
              <Typography
                sx={{
                  fontSize: { xs: '13px', md: '14px' },
                  fontWeight: 600,
                  color: '#ffb74d',
                  letterSpacing: '3px',
                  textTransform: 'uppercase',
                  marginBottom: '12px',
                  animation: 'fadeInUp 0.8s ease-out'
                }}
              >
                Premium Auto Care
              </Typography>
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: '36px', sm: '44px', md: '52px', lg: '58px' },
                  fontWeight: 'bold',
                  color: 'white',
                  lineHeight: 1.15,
                  marginBottom: { xs: '20px', md: '24px' },
                  textAlign: { xs: 'center', md: 'left' },
                  textShadow: '0 2px 20px rgba(0,0,0,0.3)',
                  animation: 'fadeInUp 0.8s ease-out 0.1s both'
                }}
              >
                Your Car Deserves the Best. We Deliver.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '16px', md: '18px' },
                  color: 'rgba(255,255,255,0.95)',
                  marginBottom: { xs: '28px', md: '32px' },
                  lineHeight: 1.65,
                  textAlign: { xs: 'center', md: 'left' },
                  textShadow: '0 1px 8px rgba(0,0,0,0.2)',
                  animation: 'fadeInUp 0.8s ease-out 0.2s both'
                }}
              >
                From routine service to full repairs—Tamil Cars keeps you on the road with trust and care. Expert technicians, modern equipment, transparent pricing.
              </Typography>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' }, animation: 'fadeInUp 0.8s ease-out 0.35s both' }}>
                <Button
                  variant="contained"
                  href="#contact_us"
                  sx={{
                    background: 'linear-gradient(135deg, #ff6f00 0%, #ff8f00 100%)',
                    color: 'white',
                    padding: { xs: '14px 32px', md: '16px 40px' },
                    fontSize: { xs: '14px', md: '16px' },
                    fontWeight: 'bold',
                    borderRadius: '10px',
                    textTransform: 'none',
                    boxShadow: '0 8px 24px rgba(255, 111, 0, 0.4)',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: '-100%',
                      width: '100%',
                      height: '100%',
                      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)',
                      transition: 'left 0.5s'
                    },
                    '&:hover': {
                      background: 'linear-gradient(135deg, #ff8f00 0%, #ff6f00 100%)',
                      boxShadow: '0 12px 28px rgba(255, 111, 0, 0.5)',
                      transform: 'translateY(-2px)',
                      '&::before': { left: '100%' }
                    },
                    '&:active': { transform: 'translateY(0)' }
                  }}
                >
                  Book a Service
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={5} sx={{ display: { xs: 'none', md: 'block' } }}>
            <Box sx={{ height: '100%', minHeight: 320 }} />
          </Grid>
        </Grid>
      </Container>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </Box>
  );
};

export default Hero;
